import NiceModal from "@ebay/nice-modal-react"
import LanguageIcon from "@mui/icons-material/Language"
import IconButton from "@mui/material/IconButton"

import { Desktop } from "../components/device"
import { useAppSelector } from "@/lib/hooks"
import type { SxStyles } from "@/types/util"
import LanguageSwitcherModal from "./language_switcher_modal"

const styles = {
  button: {
    padding: "3px",
  },
  icon: {
    fontSize: "30px",
  },
  menuItem: {
    display: "flex",
    flexDirection: "column",
    minHeight: "min-content",
    alignItems: "flex-start",
  },
} satisfies SxStyles

const ChangeLanguageButton = () => {
  const languages = useAppSelector((state) => state.configuration?.languages)
  const portalMultiLanguages = (languages?.length ?? 0) > 1

  if (!portalMultiLanguages) {
    return <></>
  }

  const changeLanguage = () => {
    void NiceModal.show(LanguageSwitcherModal)
  }

  return (
    <Desktop>
      <IconButton sx={styles.button} onClick={changeLanguage}>
        <LanguageIcon sx={styles.icon} />
      </IconButton>
    </Desktop>
  )
}

export default ChangeLanguageButton
